import { WifiOff, AlertCircle, RefreshCw, Inbox } from "lucide-react";

export const LoadingState = ({ label = "Loading", lines = 3 }) => (
  <div className="w-full" data-testid="loading-state" role="status" aria-label={label}>
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="h-32 animate-pulse rounded-2xl border border-white/5 bg-white/[0.03]"
        />
      ))}
    </div>
    <span className="sr-only">{label}</span>
  </div>
);

export const ErrorState = ({ onRetry, title = "Unable to connect to Xevon services.", message = "Please try again later." }) => (
  <div
    className="flex flex-col items-center justify-center rounded-2xl border border-white/10 bg-white/[0.02] px-8 py-20 text-center"
    data-testid="error-state"
    role="alert"
  >
    <AlertCircle className="h-10 w-10 text-paper-500" aria-hidden="true" />
    <h3 className="mt-6 font-display text-xl font-semibold text-paper-100">{title}</h3>
    <p className="mt-2 max-w-md text-sm text-paper-500">{message}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        data-testid="error-retry-button"
        className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-2.5 text-sm font-semibold text-paper-100 transition-colors duration-300 hover:bg-white hover:text-black"
      >
        <RefreshCw className="h-4 w-4" aria-hidden="true" />
        Retry
      </button>
    )}
  </div>
);

export const OfflineState = ({ onRetry }) => (
  <div
    className="flex flex-col items-center justify-center rounded-2xl border border-white/10 bg-white/[0.02] px-8 py-20 text-center"
    data-testid="offline-state"
    role="alert"
  >
    <WifiOff className="h-10 w-10 text-paper-500" aria-hidden="true" />
    <h3 className="mt-6 font-display text-xl font-semibold text-paper-100">
      Unable to connect to Xevon services.
    </h3>
    <p className="mt-2 max-w-md text-sm text-paper-500">Please try again later.</p>
    {onRetry && (
      <button
        onClick={onRetry}
        data-testid="offline-retry-button"
        className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-2.5 text-sm font-semibold text-paper-100 transition-colors duration-300 hover:bg-white hover:text-black"
      >
        <RefreshCw className="h-4 w-4" aria-hidden="true" />
        Retry
      </button>
    )}
  </div>
);

export const EmptyState = ({ title = "Nothing here yet.", message }) => (
  <div
    className="flex flex-col items-center justify-center rounded-2xl border border-white/10 bg-white/[0.02] px-8 py-20 text-center"
    data-testid="empty-state"
  >
    <Inbox className="h-10 w-10 text-paper-500" aria-hidden="true" />
    <h3 className="mt-6 font-display text-xl font-semibold text-paper-100">{title}</h3>
    {message && <p className="mt-2 max-w-md text-sm text-paper-500">{message}</p>}
  </div>
);
